import { Divider } from 'antd';
import { EnrolledProgramService } from '../../../../../services/EnrolledProgramService';
import { CarePlan } from '../../../../../uc-api-sdk';
import { PrintCarePlanBehavioralGoalComponent } from '../PrintCarePlanBehavioralGoalComponent/PrintCarePlanBehavioralGoalComponent';
import { PrintCarePlanBehaviorChangeComponent } from '../PrintCarePlanBehaviorChangeComponent/PrintCarePlanBehaviorChangeComponent';
import { PrintCarePlanClinicalGoalComponent } from '../PrintCarePlanClinicalGoalComponent/PrintCarePlanClinicalGoalComponent';
import { PrintCarePlanDiagnosisHealthConditionsComponent } from '../PrintCarePlanDiagnosisHealthConditionsComponent/PrintCarePlanDiagnosisHealthConditionsComponent';
import { PrintCarePlanDiseaseHistoryComponent } from '../PrintCarePlanDiseaseHistoryComponent/PrintCarePlanDiseaseHistoryComponent';
import { PrintCarePlanMedicationComponent } from '../PrintCarePlanMedicationComponent/PrintCarePlanMedicationComponent';
import { PrintCarePlanNutritionComponent } from '../PrintCarePlanNutritionComponent/PrintCarePlanNutritionComponent';
import { PrintCarePlanSocialSupportComponent } from '../PrintCarePlanSocialSupportComponent/PrintCarePlanSocialSupportComponent';
import { PrintCarePlanVitalsMonitoringGoalComponent } from '../PrintCarePlanVitalsMonitoringGoalComponent/PrintCarePlanVitalsMonitoringGoalComponent';
import { PrintLifeStyleComponent } from '../PrintLifeStyleComponent/PrintLifeStyleComponent';

export interface PrintGeneralCarePlanComponentProps {
  enrolledProgramService?: EnrolledProgramService;
  carePlan?: CarePlan;
}

export const PrintGeneralCarePlanComponent = ({
  enrolledProgramService,
  carePlan,
}: PrintGeneralCarePlanComponentProps) => {
  const {
    profile,
    healthCondition,
    diseaseHistory,
    lifeStyle,
    nutrition,
    clinicGoal,
    behaviorGoal,
  } = carePlan || {};
  return (
    <>
      <div className="print-care-plan-preview-clinical-goals">
        <PrintCarePlanClinicalGoalComponent
          clinicalGoals={clinicGoal?.doc?.clinicalGoals || []}
        />
      </div>
      <div className="print-care-plan-preview-vitals-monitoring-goal">
        <PrintCarePlanVitalsMonitoringGoalComponent
          monitoringVitals={enrolledProgramService?.getMonitoringVitals() || []}
        />
      </div>
      <div className="print-care-plan-preview-behavior-change">
        <PrintCarePlanBehaviorChangeComponent
          behaviorChange={profile?.behaviorChangeInfo?.behaviorChangeLevel ?? undefined}
        />
      </div>
      <div className="print-care-plan-preview-behavioral-goal">
        <PrintCarePlanBehavioralGoalComponent
          behavioralGoals={behaviorGoal?.doc?.behaviorGoals || []}
        />
      </div>
      <div className="print-care-plan-preview-medication-reconciliation-compliance">
        <PrintCarePlanMedicationComponent
          visit={carePlan?.visit}
          medication={carePlan?.medication}
          medicationList={carePlan?.medicationList}
        />
      </div>
      <div className="print-care-plan-preview-nutrition">
        <PrintCarePlanNutritionComponent
          nutrition={nutrition?.doc}
        />
      </div>
      <div className="print-care-plan-preview-lifestyle">
        <PrintLifeStyleComponent
          lifeStyle={lifeStyle?.doc}
        />
      </div>
      <div className="print-care-plan-preview-social-support">
        <PrintCarePlanSocialSupportComponent
          profile={profile}
        />
      </div>
      <div className="print-care-plan-preview-disease-history">
        <PrintCarePlanDiseaseHistoryComponent
          diseaseHistory={diseaseHistory?.diseaseHistory}
        />
      </div>
      <div className="print-care-plan-preview-health-condition">
        <PrintCarePlanDiagnosisHealthConditionsComponent
          // diagnosis={healthCondition?.diagnoses}
          healthConditions={healthCondition?.healthConditions}
        />
        <Divider />
      </div>
    </>
  );
};
